import { useState, useEffect } from "react";
import { brand, navLinks } from "../data/siteData";
import "./Navbar.css";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  return (
    <nav className={`nav ${scrolled ? "nav--scrolled" : ""}`}>
      <div className="nav__logo">
        <span className="nav__logo-icon">⬡</span>
        {brand.name}
      </div>
      <ul className={`nav__links ${open ? "nav__links--open" : ""}`}>
        {navLinks.map((l) => (
          <li key={l.label}><a href={l.href} onClick={() => setOpen(false)}>{l.label}</a></li>
        ))}
      </ul>
      <div className="nav__right">
        <a href="#contact" className="nav__cta">Get Quote</a>
        <button className="nav__burger" onClick={() => setOpen(!open)}>
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}
